import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import styled from 'styled-components'
import { AlertTriangle } from 'lucide-react'

const StyledModal = styled(Modal)`
  .modal-content {
    background: #2a2a2a;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    color: white;
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 1.5rem;
  }

  .modal-body {
    padding: 1.5rem;
    text-align: center;
  }

  .modal-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding: 1.5rem;
    justify-content: center;
  }

  .error-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #9b2c2c;
    margin: 0 auto 1.5rem;
  }

  .error-message {
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 0;
  }
`

interface ErrorDialogProps {
  show: boolean
  message: string
  onClose: () => void
}

const ErrorDialog: React.FC<ErrorDialogProps> = ({ show, message, onClose }) => {
  return (
    <StyledModal show={show} onHide={onClose} centered>
      <Modal.Body>
        <div className="error-icon">
          <AlertTriangle size={24} color="white" />
        </div>
        <h4>Error</h4>
        <p className="error-message">{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={onClose}
          style={{ background: '#553c9a', borderColor: '#553c9a' }}
        >
          Close
        </Button>
      </Modal.Footer>
    </StyledModal>
  )
}

export default ErrorDialog
